import React from 'react';
import {ISelectProps, SelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {Intent} from '~/lib/intent';
import {useResource} from '~/lib/loader';
import {ID} from '~/lib/model';
import {fetchIntegrationStatuses} from '~/modules/Clients/api';

type ISelectIntegrationStatusProps = Omit<ISelectProps<ID>, 'items'>;

export const SelectIntegrationStatus = ({
    disabled,
    ...props
}: ISelectIntegrationStatusProps) => {
    const {resource, isPending} = useResource(() => fetchIntegrationStatuses(), []);
    return <SelectInput {...props} disabled={disabled || isPending}
        rightIcon={isPending && !disabled && <i className='fa fa-spinner fa-spin'/>}
        items={resource}/>;
};

export const SelectIntegrationStatusField = (props: IFieldProps<ISelectIntegrationStatusProps>) => <FormField {...props}>
    <SelectIntegrationStatus {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
